import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import {
  getItems,
  getShowtimes,
  setKeyboardConfiguration,
  setLoyaltyData,
  setShowKeyboard,
} from "../../../redux/slices";
import { useKeyboard } from "../../../context/KeyboardContext";
import { useDispatch } from "react-redux";
import { Spinner } from "../../UI/Spinner";
import {
  DEFAULT_PHONE_COUNTRY,
  PHONE_COUNTRIES,
  composePhone,
  detectPhoneCountry,
  isValidNsn,
  toNsn,
} from "../../../utils/phoneHelper";

const LoadMemberBenefits = ({ closeFunc }) => {
  const { t } = useTranslation(["POS", "Common"]);
  const dispatch = useDispatch();
  const [countryCode, setCountryCode] = useState(DEFAULT_PHONE_COUNTRY);
  // Holds the national number alone — the selector supplies the dial code.
  const [nationalNumber, setNationalNumber] = useState("");
  const [errorMsg, setErrorMsg] = useState("");
  const { setSetSharedInput } = useKeyboard();

  const onPhoneChange = (value) => {
    // A pasted full number carries its own dial code; follow it.
    const detected = detectPhoneCountry(value);
    const country = detected || countryCode;
    if (detected && detected !== countryCode) setCountryCode(detected);
    setNationalNumber(toNsn(value, country));
  };

  const phoneNumber = composePhone(nationalNumber, countryCode);
  const onSubmit = (e) => {
    e.preventDefault();
    if (!phoneNumber) {
      setErrorMsg(t("loyalty.errors.phone.required"));
      return;
    }

    // Was `length !== 11`, which rejected every Ghanaian number.
    if (!isValidNsn(nationalNumber, countryCode)) {
      setErrorMsg(t("Common:schema.invalid.phone"));
      return;
    }
    dispatch(getItems({ phoneNumber }));
    dispatch(getShowtimes({ phoneNumber }));
    dispatch(setLoyaltyData({ phoneNumber }));
    closeFunc();
    setErrorMsg("");
  };
  return (
    <form onSubmit={onSubmit} className="h-full">
      <div className="flex flex-col justify-center items-center h-full">
        <div className="mt-6 deleteModal  flex justify-center">
          <div>
            <label className="text-center block font-bold ">
              {t("loyalty.label.phone")}
            </label>
            <br />
            {errorMsg && (
              <p className="text-red-500 text-center pb-2 "> {errorMsg}</p>
            )}
            <div className="flex">
              <select
                value={countryCode}
                onChange={(e) => {
                  const next = e.target.value;
                  setCountryCode(next);
                  setNationalNumber((current) => toNsn(current, next));
                }}
                className="h-[50px] border border-secondary border-r-0 rounded-l py-2 pl-2 pr-1 bg-white"
                aria-label={t("Common:label.country")}
              >
                {Object.values(PHONE_COUNTRIES).map((country) => (
                  <option key={country.code} value={country.code}>
                    +{country.dialCode}
                  </option>
                ))}
              </select>
              <input
                type="text"
                value={nationalNumber}
                inputMode="numeric"
                maxLength={PHONE_COUNTRIES[countryCode]?.nsnLength}
                placeholder={
                  PHONE_COUNTRIES[countryCode]?.example ||
                  t("loyalty.placeholder.phone")
                }
                className=" w-[100%]  h-[50px] border border-secondary rounded-r py-2 px-3"
                onChange={(e) => onPhoneChange(e.target.value)}
                onClick={() => {
                  dispatch(setShowKeyboard(true));
                  dispatch(
                    setKeyboardConfiguration({
                      type: "numeric",
                      sharedInput: nationalNumber,
                      placeHolder: t(
                        "Common:keyboard.placeholder.customer.phone"
                      ),
                    })
                  );
                  setSetSharedInput(() => onPhoneChange);
                }}
              />
            </div>
          </div>
        </div>

        <div className="mt-5 flex justify-center">
          <button
            type="submit"
            className=" mr-2 inline-flex items-center justify-center rounded-md border border-transparent bg-blue-100 px-4 py-2 text-sm font-medium text-blue-900 hover:bg-blue-200 focus:outline-none focus-visible:ring-2 focus-visible:ring-blue-500 focus-visible:ring-offset-2"
          >
            <span>{t("Common:button.submit")} </span>
            <Spinner
              className="!w-3 !h-3 mx-1 text-white fill-blue-800"
              //   status={status}
            />
          </button>
          <button
            type="button"
            onClick={() => {
              setNationalNumber("");
              closeFunc();
              setErrorMsg("");
            }}
            className="ml-2 inline-flex justify-center rounded-md border border-transparent bg-red-700 px-4 py-2 text-sm font-medium text-white mr-2 focus:outline-none focus-visible:ring-2 focus-visible:ring-blue-500 focus-visible:ring-offset-2"
          >
            {t("Common:button.cancel")}
          </button>
        </div>
      </div>
    </form>
  );
};

export default LoadMemberBenefits;
